import { NgModule, Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Response, Headers, Http } from '@angular/http';
import { registerDataService } from './register-data.service';
import { register } from './register';
import { Router, ActivatedRoute } from "@angular/router";
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalService } from '../model/global.service';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html'
})
export class IndexComponent implements OnInit, OnDestroy {

  //implements OnInit
  public _form: FormGroup;
  public _formErrors: any;
  private _register: register;
  public _errorMessage: string;
  private _mobileNumber: string;
  public _errorStatus: any;




  constructor(private spinnerService: Ng4LoadingSpinnerService, private _formBuilder: FormBuilder, private _registerDataService: registerDataService, private _router: Router,
    private _activatedRoute: ActivatedRoute, private _globalService: GlobalService) {
    this._form = _formBuilder.group({
      customername: ['', Validators.compose([Validators.required])],
      mobile: ['', Validators.compose([Validators.required])],
      voucher_code: ['', Validators.compose([Validators.required])],
      captcha_code: [null, Validators.compose([Validators.required])]
    })
  }

  public spinnerConfig: any = {
    bdColor: 'rgba(51,51,51,0.8)',
    size: 'large',
    color: '#fff',
    loadigText: 'Loading...'
  };

  // public onSubmit() {
  //   this._router.navigate(['/otpVerify']);
  // }


  public ngOnInit() {
    this._resetFormErrors();
    this._resetRegister();
  }


  private _resetFormErrors(): void {
    this._formErrors = {
      customername: {
        valid: true, message: ''
      },
      mobile: {
        valid: true, message: ''
      },
      voucher_code: {
        valid: true, message: ''
      }
    }
  }
  private _resetRegister() {
    this._register = new register();
    this._register.customername = '';
    this._register.mobile = '';
    this._register.voucher_code = '';
  }

  private _setFormErrors(errorFields: any): void {
    for (let key in errorFields) {
      let errorField = errorFields[key];
      // skip loop if the property is from prototype
      if (!this._formErrors.hasOwnProperty(key)) continue;

      // let message = errorFields[error.field];
      this._formErrors[key].valid = false;
      this._formErrors[key].message = errorField;
    }
  }

  public onSubmit() {
    this.spinnerService.show();
    //  let _customerName, _mobileNumber, _voucher_code, data;
    let customerId;
    console.log("Clicked");

    this._register.customername = this._form.controls['customername'].value;
    this._register.mobile = this._form.controls['mobile'].value;
    this._register.voucher_code = this._form.controls['voucher_code'].value;
    this._register.campaign_id = 1;

    this._registerDataService.submitdetails(this._register)
      .subscribe(
        result => {
          this.spinnerService.hide();
          if (result) {
            console.log("Data Sent::", result);
            this._register = result.customerdata;
            this._errorMessage = '';
            this._globalService.mobileNumber = this._register.mobile;
            this._globalService.customerID = result.customerdata.customer_id;
            console.log("OTP::", result.customerdata.otp);
            this._router.navigate(['/otpVerify']);
          }
        },
        error => {
          this.spinnerService.hide();
          this._errorStatus = error.status;
          //Validation errors
          if (error.status == 422) {
            this._errorMessage = error.message;
          }
          // Unauthorized Access
          else if (error.status == 401 || error.status == 403) {
            this._errorMessage = error.message;
          }
          // All other errors
          else {
            this._errorMessage = error.message;
          }
        }
      );
  }
  public ngOnDestroy() {
    this._register = new register();   
  }
}



// WEBPACK FOOTER //
// ./src/app/index/index.component.ts